import { useState } from "react"
import { useQuery } from "react-query"
import { httpGetRequest } from "clients/phronesisClient"
import { Tuple } from "components/Shared/Interfaces"

const useFetchFilters = <Type>(
	url: string,
	name: string,
	parameters: any = {},
	isSaved: boolean,
	key: string = name
) => {
	if (parameters !== {}) {
		parameters = prepareRequestParameters(parameters)
	}

	const [data, setData] = useState<Array<Type>>([])
	const { refetch, isFetching, isLoading } = useQuery(
		key,

		async () => {
			const response = await httpGetRequest<Type>(url, parameters)
			let filter = []
			filter = Object.values(response)[0]
			if (isSaved) {
				sessionStorage.setItem(name, btoa(JSON.stringify(filter)))
			}
			setData(filter)
		},
		{
			enabled: false,
			retry: false,
		}
	)

	return { data, setData, refetch, isFetching, isLoading } as const
}

export default useFetchFilters

export const prepareRequestParameters = (
	selectedFilters: any
): RequestParameters => {
	const {
		vendors,
		brands,
		departments,
		categories,
		subcategories,
		regions,
		counties,
		formats,
		stores,
	} = selectedFilters

	const getCode = (item: Tuple) => item.code

	return {
		vendors: vendors?.map(getCode).join(),
		brands: brands?.map(getCode).join(),
		departments: departments?.map(getCode).join(),
		categories: categories?.map(getCode).join(),
		subcategories: subcategories?.map(getCode).join(),
		region: regions?.map(getCode).join(),
		county: counties?.map(getCode).join(),
		format: formats?.map(getCode).join(),
		store: stores?.map(getCode).join(),
	}
}

interface RequestParameters {
	vendors: string
	brands: string
	departments: string
	categories: string
	subcategories: string
	region: string
	county: string
	format: string
	store: string
}
